const popupCart = document.getElementById('popup-cart');

let cartTransition = false;

async function openCart() {
	if (!popupCart || cartTransition) return;
	cartTransition = true;

	// resetQuery();
	// updateQuery('cart', 'open', { replace: true });

	document.querySelectorAll('[data-popup=cart]').forEach(cta => {
		cta.classList.add('active');
	});

	popupCart.hidden = false;

	if (popupMenu && !popupMenu.hidden) {
		await closeMenu();
	} else {
		popupCart.classList.add('animate-fade-in');
		await new Promise(resolve => setTimeout(resolve, 200));
	
		popupCart.removeAttribute('class');
	}

	cartTransition = false;
}

async function closeCart() {
	if (!popupCart || cartTransition) return;
	cartTransition = true;

	deleteQuery('cart', { replace: true });

	document.querySelectorAll('[data-popup=cart]').forEach(cta => {
		cta.classList.remove('active');
	});

	popupCart.classList.add('animate-fade-out');

	await new Promise(resolve => setTimeout(resolve, 150));

	popupCart.scrollTo(0, 0);
	popupCart.removeAttribute('class');
	popupCart.hidden = true;
	cartTransition = false;
}

if (window.location.search == '?cart=open' && popupCart.querySelectorAll('.card-item').length) {
	popupCart.hidden = false;
}

document.querySelectorAll('[data-popup=cart]').forEach(cta => {
	cta.addEventListener('click', () => {
		if (!popupCart.hidden) {
			closeCart();
		} else {
			const cartCount = Number(cta.querySelector('.cta-inline-label-info').dataset.cartCount);
			cartCount === 0
				? toggleNotice('message', 'Your shopping cart is empty')
				: openCart();
		}
	});
});

document.getElementById('popup-cart-header-close').addEventListener('click', () => {
	!popupCart.hidden && closeCart();
});

if (!isMobile) {
	document.addEventListener('keyup', e => {
		if (e.key === 'Escape') {
			!popupCart.hidden && closeCart();
		}
	});
}
